"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _vuex = require("vuex");
var _detail = _interopRequireDefault(require("./detail.vue"));
var _group = require("@/api/group");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    activityDetail: _detail.default
  },
  data: function data() {
    return {
      tableData: [],
      formData: {
        activityStatus: '',
        categoryId: '',
        groupName: '',
        groupProcess: '',
        groupStatus: '4',
        limit: 20,
        merName: '',
        page: 1,
        startTime: ''
      },
      hedaList: [],
      total: 0
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merchantClassify'])),
  created: function created() {
    if (!this.merchantClassify.length) this.$store.dispatch('merchant/getMerchantClassify');
    if ((0, _permission.checkPermi)(['platform:groupbuy:activity:list'])) this.getList();
  },
  methods: {
    selectChange: function selectChange() {
      this.formData.page = 1;
      this.getList();
    },
    search: function search() {
      this.formData.page = 1;
      this.getList();
    },
    totalOrderDoneHeader: function totalOrderDoneHeader(h, _ref) {
      var column = _ref.column;
      return this.headerText(h, column, '成团订单数：此拼团活动用户已经拼团成功的所有成功订单数统计（不包含未支付的订单数据）');
    },
    totalOrderBeginHeader: function totalOrderBeginHeader(h, _ref2) {
      var column = _ref2.column;
      return this.headerText(h, column, '参团订单数：此拼团活动用户开团的所有订单数统计（不包含未支付的订单数据）');
    },
    totalActivityDoneHeader: function totalActivityDoneHeader(h, _ref3) {
      var column = _ref3.column;
      return this.headerText(h, column, '成团数：此拼团活动用户已经拼团成功的团次数统计');
    },
    // 开团提示
    totalActivityBeginHeader: function totalActivityBeginHeader(h, _ref4) {
      var column = _ref4.column;
      return this.headerText(h, column, '开团数：此拼团活动用户开团的次数统计');
    },
    headerText: function headerText(h, column, text) {
      var serviceContent = [h('div', {
        slot: 'content'
      }, text)];
      return h('div', [h('span', column.label), h('el-tooltip', {
        props: {
          placement: 'top'
        }
      }, [serviceContent, h('i', {
        class: 'el-icon-warning-outline',
        style: 'color:#999;margin-left:5px;'
      })])]);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.limit = val;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.formData.page = page;
      this.getList();
    },
    getHead: function getHead() {
      var _this = this;
      (0, _group.groupActivityCount)(this.formData).then(function (res) {
        _this.hedaList = res;
      });
    },
    getTabList: function getTabList() {
      this.formData.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      (0, _group.groupActivityList)(this.formData).then(function (res) {
        _this2.tableData = res.list;
        _this2.total = res.total;
        _this2.getHead();
      });
    },
    //详情
    toDeatil: function toDeatil(row) {
      var _this3 = this;
      (0, _group.groupActivityInfo)(row.id).then(function (res) {
        _this3.$refs.detail.activityInfo = res;
        _this3.$refs.detail.dialogVisible = true;
      });
    },
    //关闭
    close: function close(row) {
      var _this4 = this;
      this.$modalSure('要将此活动强制关闭吗？').then(function () {
        (0, _group.groupActivityClose)(row.id).then(function (res) {
          _this4.$message({
            type: 'success',
            message: '关闭成功!'
          });
          _this4.getList();
        });
      });
    },
    //重置
    reset: function reset() {
      this.formData.activityStatus = '';
      this.formData.categoryId = '';
      this.formData.groupName = '';
      this.formData.groupProcess = '';
      this.formData.groupStatus = '4';
      this.formData.merName = '';
      this.formData.page = 1;
      this.formData.startTime = '';
      this.getList();
    }
  }
};